export enum IPublicEnumContextMenuType {
  SEPARATOR = 'separator',
  // 'menuItem'
  MENU_ITEM = 'menuItem',
  // 'nodeTree'
  NODE_TREE = 'nodeTree',
}